/* eslint-disable @typescript-eslint/naming-convention */
import { TaskGroupStatusesEnum } from "./shared";
import { IProjectTeamMemberDisplayItemsResponse } from "./teamMemberDisplayItems";

export enum TeamWizardsModeEnum {
    TEAM_ASSIGNMENT_MODE = "TEAM_ASSIGNMENT_MODE",
    JOIN_PROJECT_MODE = "JOIN_PROJECT_MODE",
    JOIN_PROJECT_GROUP_STATUSES_MODE = "JOIN_PROJECT_GROUP_STATUSES_MODE",
    TEAM_MEMBER_DISPLAY_ITEMS_GROUP_STATUSES_MODE = "TEAM_MEMBER_DISPLAY_ITEMS_GROUP_STATUSES_MODE",
    TEAM_MEMBER_WITH_CONTEXT_MENU_MODE = "TEAM_MEMBER_WITH_CONTEXT_MENU_MODE",
    LEAVE_PROJECT_MODE = "LEAVE_PROJECT_MODE",
    LEAVE_PROJECT_GROUP_STATUSES_MODE = "LEAVE_PROJECT_GROUP_STATUSES_MODE",
    OFFBOARD_TEAM_MEMBER_MODE = "OFFBOARD_TEAM_MEMBER_MODE",
    OFFBOARD_TEAM_MEMBER_GROUP_STATUSES_MODE = "OFFBOARD_TEAM_MEMBER_GROUP_STATUSES_MODE",
    PROJECT_ADMIN_ASSIGNMENT_MODE = "PROJECT_ADMIN_ASSIGNMENT_MODE",
    PROJECT_ADMIN_ASSIGNMENT_GROUP_STATUSES_MODE = "PROJECT_ADMIN_ASSIGNMENT_GROUP_STATUSES_MODE",
    REVOKE_PROJECT_ADMIN_RIGHTS_MODE = "REVOKE_PROJECT_ADMIN_RIGHTS_MODE",
    REVOKE_PROJECT_ADMIN_RIGHTS_GROUP_STATUSES_MODE = "REVOKE_PROJECT_ADMIN_RIGHTS_GROUP_STATUSES_MODE",
}

export type ITeamWizards = {
    defaultOpenState?: boolean;
} & (
    | { mode: TeamWizardsModeEnum.TEAM_ASSIGNMENT_MODE; data?: never }
    | { mode: TeamWizardsModeEnum.JOIN_PROJECT_MODE; data?: never }
    | { mode: TeamWizardsModeEnum.JOIN_PROJECT_GROUP_STATUSES_MODE; data: IProjectTeamMemberDisplayItemsResponse }
    | { mode: TeamWizardsModeEnum.TEAM_MEMBER_DISPLAY_ITEMS_GROUP_STATUSES_MODE; data: IProjectTeamMemberDisplayItemsResponse }
    | { mode: TeamWizardsModeEnum.TEAM_MEMBER_WITH_CONTEXT_MENU_MODE; data: IProjectTeamMemberDisplayItemsResponse }
    | { mode: TeamWizardsModeEnum.LEAVE_PROJECT_MODE; data: IProjectTeamMemberDisplayItemsResponse }
    | { mode: TeamWizardsModeEnum.LEAVE_PROJECT_GROUP_STATUSES_MODE; data: IProjectTeamMemberDisplayItemsResponse }
    | { mode: TeamWizardsModeEnum.OFFBOARD_TEAM_MEMBER_MODE; data: IProjectTeamMemberDisplayItemsResponse }
    | { mode: TeamWizardsModeEnum.OFFBOARD_TEAM_MEMBER_GROUP_STATUSES_MODE; data: IProjectTeamMemberDisplayItemsResponse }
    | { mode: TeamWizardsModeEnum.PROJECT_ADMIN_ASSIGNMENT_MODE; data?: IProjectTeamMemberDisplayItemsResponse }
    | { mode: TeamWizardsModeEnum.PROJECT_ADMIN_ASSIGNMENT_GROUP_STATUSES_MODE; data: IProjectTeamMemberDisplayItemsResponse }
    | { mode: TeamWizardsModeEnum.REVOKE_PROJECT_ADMIN_RIGHTS_MODE; data: IProjectTeamMemberDisplayItemsResponse }
    | { mode: TeamWizardsModeEnum.REVOKE_PROJECT_ADMIN_RIGHTS_GROUP_STATUSES_MODE; data: IProjectTeamMemberDisplayItemsResponse }
);

export interface ITeamWizardsStatusColors {
    [TeamWizardsModeEnum.TEAM_ASSIGNMENT_MODE]: {
        memberIcon: string;
    };
    [TeamWizardsModeEnum.JOIN_PROJECT_MODE]: {
        memberIcon: string;
    };
    [TeamWizardsModeEnum.JOIN_PROJECT_GROUP_STATUSES_MODE]: {
        memberIcon: {
            default: string;
            failed: string;
        };
        status: {
            [TaskGroupStatusesEnum.Pending]: string;
            [TaskGroupStatusesEnum.InProgress]: string;
            [TaskGroupStatusesEnum.Complete]: string;
            [TaskGroupStatusesEnum.Failed]: string;
        };
    };
    [TeamWizardsModeEnum.TEAM_MEMBER_DISPLAY_ITEMS_GROUP_STATUSES_MODE]: {
        memberIcon: {
            default: string;
            failed: string;
        };
        status: {
            [TaskGroupStatusesEnum.Pending]: string;
            [TaskGroupStatusesEnum.InProgress]: string;
            [TaskGroupStatusesEnum.Complete]: string;
            [TaskGroupStatusesEnum.Failed]: string;
        };
    };
    [TeamWizardsModeEnum.TEAM_MEMBER_WITH_CONTEXT_MENU_MODE]: {
        memberIcon: string;
    };
    [TeamWizardsModeEnum.LEAVE_PROJECT_MODE]: {
        memberIcon: string;
    };
    [TeamWizardsModeEnum.LEAVE_PROJECT_GROUP_STATUSES_MODE]: {
        memberIcon: {
            default: string;
            failed: string;
        };
        status: {
            [TaskGroupStatusesEnum.Pending]: string;
            [TaskGroupStatusesEnum.InProgress]: string;
            [TaskGroupStatusesEnum.Complete]: string;
            [TaskGroupStatusesEnum.Failed]: string;
        };
    };
    [TeamWizardsModeEnum.OFFBOARD_TEAM_MEMBER_MODE]: {
        memberIcon: string;
    };
    [TeamWizardsModeEnum.OFFBOARD_TEAM_MEMBER_GROUP_STATUSES_MODE]: {
        memberIcon: {
            default: string;
            failed: string;
        };
        status: {
            [TaskGroupStatusesEnum.Pending]: string;
            [TaskGroupStatusesEnum.InProgress]: string;
            [TaskGroupStatusesEnum.Complete]: string;
            [TaskGroupStatusesEnum.Failed]: string;
        };
    };
}
